import { render, staticRenderFns } from "./Committees.vue?vue&type=template&id=dd721f90&"
import script from "./Committees.vue?vue&type=script&lang=js&"
export * from "./Committees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports